import React, { useMemo, useState } from 'react';
import { useManagedLanguages } from '../hooks/useManagedLanguages';

const PortalLanguages = () => {
  const { languageEntries, availableToAdd, addLanguage } = useManagedLanguages();
  const [selectedCode, setSelectedCode] = useState('');
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(null);

  const activeList = useMemo(
    () =>
      languageEntries.map(([code, meta]) => ({
        code,
        label: meta.label || code.toUpperCase(),
        nativeName: meta.nativeName || meta.label || code.toUpperCase(),
      })),
    [languageEntries]
  );

  const handleAdd = async () => {
    if (!selectedCode) return;
    setSaving(true);
    setStatus(null);
    try {
      await addLanguage(selectedCode);
      setStatus({ type: 'success', msg: 'Language added. Selectors will update automatically.' });
      setSelectedCode('');
    } catch (err) {
      setStatus({ type: 'error', msg: err?.message || 'Failed to add language.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'grid', gap: '18px' }}>
      <div
        style={{
          border: '1px solid rgba(19, 138, 138, 0.35)',
          borderRadius: '10px',
          background: 'rgba(2, 6, 23, 0.45)',
          padding: '18px',
        }}
      >
        <h3 style={{ margin: '0 0 10px 0', color: '#dbeafe' }}>Portal Languages</h3>
        <p style={{ margin: 0, color: '#94a3b8', fontSize: '0.86rem' }}>
          Active languages are used by portal selectors and localization workflows.
        </p>
      </div>

      <div
        style={{
          border: '1px solid rgba(148, 163, 184, 0.25)',
          borderRadius: '10px',
          background: 'rgba(15, 23, 42, 0.65)',
          padding: '18px',
        }}
      >
        <h4 style={{ margin: '0 0 12px 0', color: '#e2e8f0' }}>Add language</h4>
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <select
            value={selectedCode}
            onChange={(e) => setSelectedCode(e.target.value)}
            style={{
              flex: 1,
              padding: '9px 10px',
              borderRadius: '6px',
              background: '#0b1220',
              color: '#e2e8f0',
              border: '1px solid #334155',
            }}
          >
            <option value="">Select a language to activate...</option>
            {availableToAdd.map((item) => (
              <option key={item.code} value={item.code}>
                {item.label} | {item.nativeName}
              </option>
            ))}
          </select>
          <button
            type="button"
            onClick={handleAdd}
            disabled={!selectedCode || saving}
            className="btn-workflow-step"
            style={{ margin: 0, opacity: !selectedCode || saving ? 0.55 : 1 }}
          >
            {saving ? 'Adding...' : 'Add language'}
          </button>
        </div>
        {status && (
          <div
            style={{
              marginTop: '12px',
              fontSize: '0.82rem',
              color: status.type === 'success' ? '#4ade80' : '#f87171',
            }}
          >
            {status.msg}
          </div>
        )}
      </div>

      <div
        style={{
          border: '1px solid rgba(148, 163, 184, 0.25)',
          borderRadius: '10px',
          background: 'rgba(15, 23, 42, 0.65)',
          padding: '18px',
        }}
      >
        <h4 style={{ margin: '0 0 12px 0', color: '#e2e8f0' }}>Active languages (A-Z)</h4>
        <div style={{ display: 'grid', gap: '6px' }}>
          {activeList.map((item) => (
            <div
              key={item.code}
              style={{
                border: '1px solid rgba(51, 65, 85, 0.8)',
                borderRadius: '6px',
                background: '#0b1220',
                padding: '8px 10px',
                color: '#cbd5e1',
                fontSize: '0.85rem',
              }}
            >
              {item.label} | {item.nativeName}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortalLanguages;
